import React from "react"
import { Flex, Box, Text } from "rebass"
import { get } from "lodash"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"
import IconButton from "@material-ui/core/IconButton"
import { EditIcon } from "../../components/icon_svg"
import { TrashPOIcon } from "../../components/icon_svg"
import { withStyles } from "@material-ui/core/styles"

import {
  styles,
  StyledTableAction,
  StyledTableCell,
  StyledTableRow,
  StyledTableSmall,
  StyledTableRowLast,
} from "./styles"
import { PromotionField } from "./customer"

const OrderItems = (props) => {
  const { formData, translate, classes, onRemoveItem, onEditItem } = props
  const items = get(formData, "items", [])
  let total = 0
  return (
    <Box width={[1]} p={[3]}>
      <Text color={"green"} pb={[3]}>
        {translate("resources.po.fields.order_cart")}
      </Text>
      {items.length > 0 && (
        <TableContainer component={"div"}>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>
                  {translate("resources.po.fields.product")}
                </StyledTableCell>
                <StyledTableSmall>
                  {translate("resources.po.fields.code")}
                </StyledTableSmall>
                <StyledTableSmall>
                  {translate("resources.po.fields.qty")}
                </StyledTableSmall>
                <StyledTableSmall>
                  {translate("resources.po.fields.price")}
                </StyledTableSmall>
                <StyledTableSmall>
                  {translate("resources.po.fields.subtotal")}
                </StyledTableSmall>
                <StyledTableAction />
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item, index) => {
                total = total + item.result.subtotal
                return (
                  <StyledTableRow key={index}>
                    <StyledTableCell component="td" scope="row">
                      <Box>
                        <Text>{item.product.packaging}</Text>
                        <PromotionField
                          record={item.product}
                          source="name"
                          resource_id="id"
                        />
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell component="td" scope="row">
                      <Text>{item.product.code}</Text>
                    </StyledTableCell>
                    <StyledTableCell component="td" scope="row">
                      <Text>{item.result.qty}</Text>
                    </StyledTableCell>
                    <StyledTableCell component="td" scope="row">
                      <Text>{item.result.price}</Text>
                    </StyledTableCell>
                    <StyledTableCell component="td" scope="row">
                      <Text>{item.result.subtotal}</Text>
                    </StyledTableCell>
                    <StyledTableAction component="td" scope="row">
                      <Flex flexDirection={"row"} alignItems={"center"}>
                        <IconButton
                          className={classes.leftIcon}
                          onClick={() => onRemoveItem(item, items)}
                        >
                          <TrashPOIcon fontSize="small" />
                        </IconButton>

                        <IconButton onClick={() => onEditItem(item)}>
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <Box width={"10px"} />
                      </Flex>
                    </StyledTableAction>
                  </StyledTableRow>
                )
              })}
              <StyledTableRowLast>
                <StyledTableCell />
                <StyledTableCell />
                <StyledTableCell />
                <StyledTableCell>
                  <Text fontWeight={"bold"}>
                    {translate("resources.po.fields.total")}
                  </Text>
                </StyledTableCell>
                <StyledTableCell>
                  <Text fontWeight={"bold"}>{total}</Text>
                </StyledTableCell>
                <StyledTableAction />
              </StyledTableRowLast>
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  )
}

export default withStyles(styles)(OrderItems)
